import { fonts, fontSize } from "config/styles/fonts";

const styles = {
  textareaWrap: {
    position: "relative",
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    alignItems: "center",
    gap: {
      xs: "10px",
      md: "20px",
    },

    "& > textarea": {
      width: "100%",
      fontFamily: fonts.text,
      fontSize: fontSize.m,
      padding: "10px 16px 30px 16px",
      borderRadius: "4px",
      border: "1px solid",
      borderColor: "gray.disabled",
      color: "text.primary",
      lineHeight: "normal",
      resize: "none",
      "&:focus-visible": {
        outlineColor: "text.secondary",
      },
      "&::placeholder": {
        fontFamily: fonts.text,
        fontSize: fontSize.m,
        color: "text.secondary",
      },
    },
  },
  counter: {
    position: "absolute",
    right: "8px",
    bottom: "8px",
    color: "gray.disabled",
  },
};

export default styles;
